/*
 * @Author: linguang linguang@nextmar.com
 * @Date: 2025-03-13 15:40:00
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-07-28 16:40:16
 * @FilePath: /code/zeelool-nextjs/src/theme/zeelool.theme.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// 全局系统颜色、字体配置，适用于 tailwind 和 Mui

// 主题规范取自：https://lanhuapp.com/link/#/invite?sid=lx0oGmsz
export const colors = {
  /** 主题色 */
  primaryPurple: '#463AE8', // 主题色-蓝色  2025 颜色规范
  primaryPurpleHover: '#584DEA', // 主题色-蓝色-hover  2025 颜色规范
  primaryPurpleActive: '#3F34D1', // 主题色-蓝色-active  2025 颜色规范
  primaryPurpleDisable: 'rgba(70,58,232,0.2);', // 主题色-蓝色-disable  2025 颜色规范

  primaryGreen: '#C7FF57', // 主题色-绿色  2025 颜色规范
  primaryGreenHover: '#d2ff79', // 主题色-绿色-hover  2025 颜色规范
  primaryGreenActive: '#bdf253', // 主题色-绿色-active  2025 颜色规范
  primaryGreenDisable: 'rgba(199,255,87, 0.4)', // 主题色-绿色-disable  2025 颜色规范

  primaryBlack: '#282828', // 主题色-黑色  2025 颜色规范
  primaryBlackHover: '#3d3d3d', // 主题色-黑色-hover  2025 颜色规范
  primaryBlackActive: '#080808', // 主题色-黑色-active  2025 颜色规范
  primaryBlackDisable: 'rgba(40,40,40,0.3)', // 主题色-黑色-disable  2025 颜色规范

  primaryWhite: '#FFFFFF', // 主题色-白色  2025 颜色规范
  primaryWhiteHover: '#F2F2F2', // 主题色-白色-hover  2025 颜色规范
  primaryWhiteActive: '#E5E5E5', // 主题色-白色-active  2025 颜色规范
  primaryWhiteDisable: 'rgba(255,255,255,0.5)', // 主题色-白色-disable  2025 颜色规范

  /** 辅助色 */
  auxiliaryLilacPurple: '#BAACFF', // 辅助色-紫丁香  2025 颜色规范
  auxiliaryLightPurple: '#ECEBFD', // 辅助色-紫丁香-hover  2025 颜色规范
  auxiliaryLightGray: '#EEEEEE', // 辅助色-浅灰色  2025 颜色规范
  auxiliaryDarkGray: '#808080', // 辅助色-深灰色  2025 颜色规范
  auxiliaryDarkBlue: '#051431', // 辅助色-深蓝色  2025 颜色规范
  auxiliaryGray: '#F4F4F4', // 辅助色-灰色  2025 颜色规范
  auxiliaryRoseRed: '#FCA6FF', // 辅助色-玫红 - 2025 颜色规范
  auxiliaryOrange: '#FF8701', // 辅助色-橙色 - 2025 颜色规范
  auxiliaryLightBlue: '#edf2fc', // 辅助色-浅蓝色 - 2025 颜色规范

  auxiliaryLightGrayBlue: '#d0d4db', // 边框色-浅灰色

  // 字体相关
  primaryText: '#282828', // 一级文字
  auxiliaryText: '#808080', // 辅助文字
  secondaryText: '#A9A9A9', // 次要文字

  // 提示相关，可能作为背景色也可能为文字色
  error: '#bc1b1b', // 错误颜色
  warning: '#B06814', // 警告颜色
  success: '#299373', // 成功颜色
};

export const font = {
  // 来自品牌换新字体
  bb: 'var(--font-bricolage-bold)',
  br: 'var(--font-bricolage)',
  be: 'var(--font-bricolage-extrabold)',
  bs: 'var(--font-bricolage-semibold)',
  ir: 'var(--font-instrument)',
  is: 'var(--font-instrument-semibold)',
  ib: 'var(--font-instrument-bold)',
};
